<template>
    <div class="row">

        <div class="col-lg-2 col-md-3 col-sm-4 col-5">
            <div class="logo-area default">
                <a>
                    <img src="/assets/img/logo.png" />
                </a>
            </div>
        </div>
        <div class="col-lg-6 col-md-5 col-sm-8 col-7">
            <!--<search-box></search-box>-->
        </div>
        <div class="col-md-4 col-sm-12" style="display:flex;justify-content:left;align-items:center">
            <!--<div class="user-login dropdown" v-if="!isUserLogined">
                <a href="#" title="ورود / ثبت نام" class="btn btn-neutral dropdown-toggle" data-toggle="dropdown"
                   id="navbarDropdownMenuLink1">
                    <span> <i style="top: 4px;right: -2px;" class="now-ui-icons media-1_button-power"></i> </span> ورود / ثبت نام
                </a>
                <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink1">
                    <div class="dropdown-item">
                        <router-link to="/" title="ورود به دیجی سرور" class="btn btn-info">ورود به دیجی سرور</router-link>
                    </div>
                    <div class="dropdown-item font-weight-bold">
                        <span>کاربر جدید هستید؟</span> <router-link to="/register" title="ثبت نام" class="register">ثبت‌نام</router-link>
                    </div>
                </ul>
            </div>-->
            <!--<div class="user-login dropdown">
                <a href="#" class="btn btn-neutral">
                    <span><i style="top: 4px;right: -2px;" class="now-ui-icons users_single-02"></i></span> {{ userFullName }}
                </a>-->
                <!--<ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink1">
                    <li class="dropdown-item order">
                        <i class="now-ui-icons shopping_bag-16"></i>
                        <router-link class="all-width" to="/orders" title="پروفایل من" tag="a">پروفایل من</router-link>
                    </li>
                    <li><hr /></li>
                    <li class="dropdown-item font-weight-bold signOut">
                        <i class="now-ui-icons media-1_button-power"></i>
                        <a class="all-width" title="خروج از حساب کاربری" >خروج از حساب کاربری</a>
                    </li>
                </ul>-->
            <!--</div>-->
            <!--<div class="cart">
                <a style="padding: 11px 10px;" title=" " class="btn" @click="signout">
                    خروج از سیستم
                </a>
            </div>-->
            <!--<header-cart></header-cart>-->
        </div>
    </div>
</template>

<script>
    //import headerCart from "./headerCart.vue";
    //import searchBox from "./searchBox.vue"
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        components: {
            //'header-cart': headerCart,
            //'search-box': searchBox
        },
        computed: {
            cart: function () {
                return this.$store.getters.readCart;
            },
            userFullName: function () {
                return this.$store.getters.readUserFullName;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            signout() {
                localStorage.removeItem('accessToken');
                this.$store.commit('setUserFullName', '');
                this.isUserLogined = false;
                window.location.href = "/";
            },
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
    }
</script>

<style scoped>
    .all-width {
        display: inline-block;
        width: 75%;
    }

    .order .shopping_bag-16, .signOut .media-1_button-power {
        text-align: right !important;
        font-size: 18px !important;
        color: #333 !important;
        opacity: .6 !important;
        padding-left: 10px;
        padding-right: 15px;
        vertical-align: middle;
    }

    .order, .signOut {
        text-align: right !important;
    }

    .user-login ul li {
        cursor: pointer;
    }
</style>